import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpAction } from '../symbolLp.action';

type IDependencies = IClientApiDependencySegment;

export const removeSymbolLpEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.remove.started),
  switchMap((params) => {
    return dependencies.api.deleteLpSymbol(params).pipe(
      mergeMap(() => {
        return [
          SymbolLpAction.remove.done({ params }),
          SymbolLpAction.loadUnmapped.started({ lpId: params.lpId }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolLpAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
